/* eslint-disable camelcase */
import React from 'react';

import useHasFeature, { featureNames } from '~/shared/utils/useHasFeature';
import { useBreakpoint } from '~/techstyle-shared/react-components';

import BuilderCollection from './BuilderCollection';
import BuilderProductsV2GridV1_1 from './BuilderProductsV2GridV1_1';
import BuilderProductsV2GridV2 from './BuilderProductsV2GridV2';

export * from './BuilderCollection.builder';

const BuilderProductsV2GridSwitch = (props) => {
  const { enabled: isGridV1_1Enabled } = useHasFeature(
    featureNames.PRODUCTS_V2_GRID_V1_1
  );

  const { enabled: isGridV2Enabled } = useHasFeature(featureNames.GRID_V2);

  const { isMobile } = useBreakpoint();

  // TODO: handle as separate component in grid redesign
  // eslint-disable-next-line react/prop-types
  const isCarouselV2Obj = props?.builderBlock?.component?.options?.isCarouselV2;
  const isCarouselV2 = isMobile
    ? isCarouselV2Obj?.mobile
    : isCarouselV2Obj?.desktop;

  if (isGridV2Enabled && !isCarouselV2) {
    return <BuilderProductsV2GridV2 {...props} />;
  }

  if (isGridV1_1Enabled && !isCarouselV2) {
    // eslint-disable-next-line react/jsx-pascal-case
    return <BuilderProductsV2GridV1_1 {...props} />;
  }

  return <BuilderCollection {...props} />;
};

export default BuilderProductsV2GridSwitch;
